'use strict';

var customerZone = angular.module('jim-customer-zone', ['gettext', '720kb.datepicker', 'ngSanitize', 'ngRoute',
    'ngMessages', 'vcRecaptcha', 'ui.mask'])

/**
 * Base controller for the application.  This contains the global state of the application that can be accessed by
 * all views (such as current session)
 */
    .controller('applicationController', ['$scope', '$window', '$route', 'Session', 'BalanceService',
        'AuthenticationService', 'BudskapService', 'utils',
        function($scope, $window, $route, Session, BalanceService, AuthenticationService, BudskapService, utils){

            var self = this;
            self.balance = {};

            self.user = {
                firstName: function(){
                    var profile = Session.profile();
                    if (!profile) return '';
                    return profile.firstName;
                },
                name: function(){
                    var profile = Session.profile();
                    if (!profile) return '';
                    return profile.firstName + ' ' + profile.lastName;
                },
                loggedIn: function(){
                    return Session.authenticated();
                },
                profile: function(){
                    return Session.profile();
                },
                subscriber: function(){
                    return Session.subscriber();
                },
                subscribers: function(){
                    return Session.subscribers();
                },
                isPrepaid: function(){
                    var subscriber = Session.subscriber();
                    return subscriber && subscriber.isPrepaid();
                },
                isPostpaid: function(){
                    var subscriber = Session.subscriber();
                    return subscriber && subscriber.isPostpaid();
                },
                hasInvoices: function(){
                    return Session.flags('hasInvoices');
                },
                impersonating: function(){
                    return Session.impersonating();
                },
                logout: function(){
                    Session.destroy();
                    if (window.enableNgRouting && $route.current.$$route && $route.current.$$route.requiresAuth) {
                        self.loggingOut = true;
                        jim.goHome();
                    }
                },
                pickSubscriber: function(subscriber){
                    Session.subscriber(subscriber);
                }
            };

            self.impersonate = function(){
                var token = $window.location.hash;
                if (!token || token.length === 0) return;
                token = token.substr(1); //location.hash adds the hash itself as a first character
                AuthenticationService.impersonate(token).then(function(){
                    jim.goHome();
                }).catch(function(){
                    utils.showError('impersonation_failed');
                });
            };

            self.balance = BalanceService.balance;
            BalanceService.refresh();

            self.voicemailConfigFaq = utils.translate('voicemail_config_faq');

            $scope.$on('balanceRefreshed', function(event, balance){
                self.balance =  balance;
            });
        }])

    .run(['$rootScope', 'config',
        function ($rootScope, config) {
            $rootScope.baseUrl = config.baseUrl;
            $rootScope.eserviceUrl = config.eserviceUrl;
        }]);


/**
 * Little helper for angular, to generate a function that will return
 * any relative url to an absolute one.
 */
customerZone.fromBase = function(relativeUrl){
    return ['config', function(config){
        return config.baseUrl + (relativeUrl[0] === '/' ? '' : '/') + relativeUrl;
    }];
};

